module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h2', [_vm._v("Table of Contents")]), _vm._v(" "), _c('ol', {
    staticClass: "bbb-rw",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s001BookTitlePage01"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s002Copyright01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s004Dedication01"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s005Chapter001"
    }
  }, [_vm._v("Chapter 1: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s006Chapter002"
    }
  }, [_vm._v("Chapter 2: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s007Chapter003"
    }
  }, [_vm._v("Chapter 3: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s008Chapter004"
    }
  }, [_vm._v("Chapter 4: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s010Chapter005"
    }
  }, [_vm._v("Chapter 5: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s011Chapter006"
    }
  }, [_vm._v("Chapter 6: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s012Chapter007"
    }
  }, [_vm._v("Chapter 7: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s014Chapter008"
    }
  }, [_vm._v("Chapter 8: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s015Chapter009"
    }
  }, [_vm._v("Chapter 9: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s016Chapter010"
    }
  }, [_vm._v("Chapter 10: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s017Chapter011"
    }
  }, [_vm._v("Chapter 11: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s018Chapter012"
    }
  }, [_vm._v("Chapter 12: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s019Chapter013"
    }
  }, [_vm._v("Chapter 13: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s020Chapter014"
    }
  }, [_vm._v("Chapter 14: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s021Chapter015"
    }
  }, [_vm._v("Chapter 15: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s022Chapter016"
    }
  }, [_vm._v("Chapter 16: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s023Chapter017"
    }
  }, [_vm._v("Chapter 17: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s025Chapter018"
    }
  }, [_vm._v("Chapter 18: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s026Chapter019"
    }
  }, [_vm._v("Chapter 19: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s027Chapter020"
    }
  }, [_vm._v("Chapter 20: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s028Chapter021"
    }
  }, [_vm._v("Chapter 21: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s029Chapter022"
    }
  }, [_vm._v("Chapter 22: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s031Chapter023"
    }
  }, [_vm._v("Chapter 23: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s032Chapter024"
    }
  }, [_vm._v("Chapter 24: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s033Chapter025"
    }
  }, [_vm._v("Chapter 25: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s034Chapter026"
    }
  }, [_vm._v("Chapter 26: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s036Chapter027"
    }
  }, [_vm._v("Chapter 27: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s037Chapter028"
    }
  }, [_vm._v("Chapter 28: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s038Chapter029"
    }
  }, [_vm._v("Chapter 29: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s039Chapter030"
    }
  }, [_vm._v("Chapter 30: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s041Chapter031"
    }
  }, [_vm._v("Chapter 31: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s042Chapter032"
    }
  }, [_vm._v("Chapter 32: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s043Chapter033"
    }
  }, [_vm._v("Chapter 33: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s044Chapter034"
    }
  }, [_vm._v("Chapter 34: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s045Chapter035"
    }
  }, [_vm._v("Chapter 35: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s047Chapter036"
    }
  }, [_vm._v("Chapter 36: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s048Chapter037"
    }
  }, [_vm._v("Chapter 37: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s050Chapter038"
    }
  }, [_vm._v("Chapter 38: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s051Chapter039"
    }
  }, [_vm._v("Chapter 39: Travis")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s052Chapter040"
    }
  }, [_vm._v("Epilogue: Saylor")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s053Acknowledgments01"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s054AboutTheAuthor01"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s055AdCard01"
    }
  }, [_vm._v("Also by Heidi McLaughlin")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s056FrontSales01"
    }
  }, [_vm._v("Praise")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/s057Appendix01"
    }
  }, [_vm._v("Newsletters")])])])]), _vm._v(" "), _c('nav', {
    staticClass: "ccc-rw",
    attrs: {
      "epub:type": "landmarks"
    }
  }, [_c('h2', [_vm._v("\n    Navigation\n   ")]), _vm._v(" "), _c('ol', {
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/s005Chapter001#Chapter41"
    }
  }, [_vm._v("\n      Begin Reading\n     ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/TOC"
    }
  }, [_vm._v("\n      Table of Contents\n     ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0f5ac7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TOC.vue
// module id = 66
// module chunks = 0